import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Button, Card, Col, Form, Row, Spinner } from 'react-bootstrap';
import { api } from '../lib/api';
import { useAuth } from '../context/AuthContext';
import { useToast } from '../context/ToastContext';
import CampoSenha from '../components/CampoSenha';
import { destinoPermitido } from '../lib/menu';

// Gate obrigatório (ver components/RotaProtegida.js) — aparece quando
// `usuario.precisaTrocarSenha` (senha padrão "123mudar" nunca trocada, ou
// mais de 30 dias desde a última troca, ver painel-eimovel-node v1.10.0).
// Sempre pede a senha ATUAL, mesmo já logado (o backend também exige,
// nunca confia só na sessão).
export default function TrocarSenha() {
  const { usuario, atualizarUsuario } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const toast = useToast();
  // Forçada (senha padrão ainda não trocada) x voluntária (link "Alterar senha" no topo)
  const forcada = !!usuario?.precisaTrocarSenha;
  const [senhaAtual, setSenhaAtual] = useState('');
  const [novaSenha, setNovaSenha] = useState('');
  const [confirmacao, setConfirmacao] = useState('');
  const [salvando, setSalvando] = useState(false);

  async function aoEnviar(e) {
    e.preventDefault();

    // o tamanho mínimo real é o configurado pelo superadmin e conferido pelo servidor (a mensagem dele aparece se não bater)
    if (novaSenha.length < 4) {
      toast.erro('A nova senha é curta demais');
      return;
    }
    if (novaSenha !== confirmacao) {
      toast.erro('A confirmação não bate com a nova senha');
      return;
    }

    setSalvando(true);
    try {
      const { usuario: usuarioAtualizado } = await api.post('/auth/trocar-senha', { senhaAtual, novaSenha });
      atualizarUsuario(usuarioAtualizado);
      toast.sucesso('Senha trocada com sucesso.');
      // antes ficava parado nesta tela (com o formulário ainda preenchido) depois de trocar. Se veio
      // parar aqui por causa de um link direto (RotaProtegida guardou em "de"), volta pra lá.
      const candidato = location.state?.de || '/';
      navigate(destinoPermitido(candidato, usuarioAtualizado) ? candidato : '/', { replace: true });
    } catch (err) {
      toast.erro(err.message || 'Não foi possível trocar a senha');
    } finally {
      setSalvando(false);
    }
  }

  return (
    <Row className="justify-content-center">
      <Col md={6} lg={5}>
        <Card>
          <Card.Body>
            <Card.Title as="h1" className="h4 mb-3">
              {forcada ? 'Crie a sua senha para continuar' : 'Alterar minha senha'}
            </Card.Title>
            <p className="text-muted">
              {forcada
                ? 'Seu acesso foi criado com uma senha provisória. Por segurança, escolha agora uma senha só sua para continuar usando o painel.'
                : 'Informe sua senha atual e escolha a nova.'}
            </p>

            <Form onSubmit={aoEnviar}>
              <Form.Group className="mb-3" controlId="senhaAtual">
                <Form.Label>Senha atual</Form.Label>
                <CampoSenha
                  value={senhaAtual}
                  onChange={(e) => setSenhaAtual(e.target.value)}
                  required
                  autoFocus
                />
              </Form.Group>
              <Form.Group className="mb-3" controlId="novaSenha">
                <Form.Label>Nova senha</Form.Label>
                <CampoSenha
                  value={novaSenha}
                  onChange={(e) => setNovaSenha(e.target.value)}
                  required
                  minLength={4}
                />
              </Form.Group>
              <Form.Group className="mb-3" controlId="confirmacao">
                <Form.Label>Confirme a nova senha</Form.Label>
                <CampoSenha
                  value={confirmacao}
                  onChange={(e) => setConfirmacao(e.target.value)}
                  required
                  minLength={4}
                />
              </Form.Group>
              <Button type="submit" variant="primary" disabled={salvando}>
                {salvando ? <Spinner animation="border" size="sm" /> : 'Trocar senha'}
              </Button>
            </Form>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
}
